/**
 * 图床管理模块
 * 
 * 图库管理、媒体上传下载、公开策略、API Token
 */

import type { WorkbenchModule } from '../types'

export const galleryModule: WorkbenchModule = {
  meta: {
    name: 'gallery',
    title: '图床管理',
    description: '图库管理、媒体文件、公开策略、API Token',
    version: '0.1.0'
  },
  routes: [
    {
      path: '/gallery',
      name: 'gallery',
      component: () => import('./views/GalleryListView.vue'),
      meta: { title: '图床管理' }
    },
    {
      path: '/gallery/:id',
      name: 'gallery-detail',
      component: () => import('./views/GalleryDetailView.vue'),
      meta: { title: '图库详情' }
    },
    {
      path: '/gallery/settings',
      name: 'gallery-settings',
      component: () => import('./views/GallerySettingsView.vue'),
      meta: { title: '图床设置' }
    }
  ],
  menuItem: {
    id: 'gallery',
    label: '图床管理',
    path: '/gallery',
    icon: 'gallery',
    order: 30
  }
}
